import useGetSiteImages from "./useGetSiteImages";
import { siteImageProps } from "../utils/siteImages";

// <img> props for one place of constants/siteImages; no src until the API
// answers, so the bundled file isn't downloaded and then replaced
const useSiteImage = ({ slot, fallback }, sizes) => {
  const { siteImages, isLoadingSiteImages } = useGetSiteImages();
  if (isLoadingSiteImages) {
    return {};
  }
  return siteImageProps(siteImages[slot], fallback, sizes);
};

export default useSiteImage;
